import { useEffect, useState } from 'react';
import { onTokenChanged } from '~/services/auth/token.events';
import { useTokenStore } from '~/store/modules/token/useTokenStore';

export function useAccessTokenFromStore() {
  const [accessToken, setAccessToken] = useState(() => useTokenStore.getAccess());

  useEffect(() => {
    const sync = () => setAccessToken(useTokenStore.getAccess());
    sync();

    return onTokenChanged(sync);
  }, []);

  return accessToken;
}
